export const Company = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 26">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
      d="M18.38 24.226V1H2.654v23.226m20.69 0V7.968h-4.966M25 25H13.414M1 25h7.448m0 0v-7.742h4.966V25m-4.966 0h4.966M5.138 7.194V3.323h3.31v3.87h-3.31Zm0 6.967v-3.87h3.31v3.87h-3.31Zm7.448-10.838h3.31v3.87h-3.31v-3.87Zm0 6.967h3.31v3.871h-3.31v-3.87Z"
    />
  </svg>
)
